/** Shared IAM permissions (user mgmt + admin) used alongside CRM call-center permissions. */
export const SHARED_CALL_CENTER_PERMISSIONS = [
    { id: 91, action: 'ROLE_ADMIN', description: 'Super-admin access - Master permission that bypasses all checks' },
    { id: 149, action: 'CUSTOMER:READ', description: 'View and access customer information and records' },
    { id: 202, action: 'ROLE:CREATE', description: 'Auto-imported permission' },
    { id: 203, action: 'ROLE:UPDATE', description: 'Auto-imported permission' },
    { id: 204, action: 'ROLE:READ', description: 'Auto-imported permission' },
    { id: 205, action: 'ROLE:DELETE', description: 'Auto-imported permission' },
    { id: 206, action: 'USER:CREATE', description: 'Auto-imported permission' },
    { id: 207, action: 'USER:UPDATE', description: 'Auto-imported permission' },
    { id: 208, action: 'USER:READ', description: 'Auto-imported permission' },
    { id: 209, action: 'USER:DELETE', description: 'Auto-imported permission' },
    { id: 210, action: 'UnlockUser', description: 'Manually unlock user accounts locked after failed login attempts' },
];
/** CRM call-center permission catalogue (IDs from production `permission` table). */
export const CRM_CALL_CENTER_PERMISSIONS = [
    // Agent & Productivity
    { id: 293, action: 'AgentPanel:Read', description: 'Access agent panel for handling customer interactions' },
    { id: 294, action: 'AgentProductivityReport:Admin', description: 'Access all Agent Productivity reporting, analytics, and statistics (used in UI)' },
    // Airplane Ticket
    { id: 295, action: 'AirplaneTicket:Create', description: 'Create new airplane ticket offers for customers' },
    { id: 296, action: 'AirplaneTicket:Read', description: 'View and manage airplane ticket bookings and pending offers' },
    // Audit
    { id: 297, action: 'AUDIT_LOG:READ', description: 'View audit logs' },
    // BlackList
    { id: 298, action: 'BlackList:Create', description: 'Add phone numbers to blacklist' },
    { id: 299, action: 'BlackList:Delete', description: 'Remove phone numbers from blacklist' },
    { id: 300, action: 'BlackList:Manage', description: 'Full management of blacklist (comprehensive permission)' },
    { id: 301, action: 'BlackList:Read', description: 'View blacklisted phone numbers' },
    { id: 302, action: 'BlackList:Update', description: 'Modify existing blacklisted entries' },
    // Branch
    { id: 303, action: 'Branch:Create', description: 'Create new Branch' },
    { id: 304, action: 'Branch:Delete', description: 'Delete Branch' },
    { id: 305, action: 'Branch:Read', description: 'View and manage Branch' },
    { id: 306, action: 'Branch:Update', description: 'Update existing Branch' },
    // Bulk Service
    { id: 307, action: 'BulkService:Create', description: 'Create bulk service operations' },
    { id: 308, action: 'BulkService:Delete', description: 'Delete bulk service operations' },
    { id: 309, action: 'BulkService:Read', description: 'Access bulk service operations' },
    { id: 310, action: 'BulkService:Update', description: 'Update bulk service operations' },
    // Call Center
    { id: 311, action: 'Call_Center:AgentMonitoring', description: '[PAGE] Agent Monitoring - Real-time agent status' },
    { id: 312, action: 'Call_Center:BlackList', description: '[PAGE] Blacklist Management - Manage blacklisted numbers' },
    { id: 313, action: 'Call_Center:Dashboard', description: '[PAGE] QStat Dashboard - Call center overview and KPI' },
    { id: 314, action: 'Call_Center:IncomingCalls', description: '[PAGE] Incoming Calls Report - Incoming call analytics' },
    { id: 315, action: 'Call_Center:KpiDashboard', description: '[PAGE] KPI Dashboard - Key performance indicators' },
    { id: 316, action: 'Call_Center:OutgoingCalls', description: '[PAGE] Outgoing Calls Report - Outgoing call analytics' },
    { id: 317, action: 'Call_Center:Queue_Status', description: '[PAGE] List of Queue Status - Manage blacklisted numbers' },
    { id: 318, action: 'Call_Center:Read', description: 'Access QStat call center monitoring and statistics dashboard' },
    { id: 319, action: 'Call_Center:RealTime', description: '[PAGE] Real-time Monitoring - Live call center status' },
    { id: 320, action: 'Call_Center:ReceivedCalls', description: '[PAGE] Received Calls - Call detail listing' },
    { id: 321, action: 'Call_Center:Voicemail', description: '[PAGE] Voicemail Management - Access and manage voicemails' },
    // Campaign
    { id: 322, action: 'Campaign:Create', description: 'Create new campaigns' },
    { id: 323, action: 'Campaign:Delete', description: 'Delete campaigns' },
    { id: 324, action: 'Campaign:Edit', description: 'Edit and update existing campaigns' },
    { id: 325, action: 'Campaign:ManageLeads', description: 'Manage leads within campaigns (add, assign, import)' },
    { id: 326, action: 'Campaign:Read', description: 'View and list campaigns' },
    { id: 327, action: 'Campaigns:Create', description: '[PAGE] Create Campaign - New campaign form' },
    { id: 328, action: 'Campaigns:Dashboard', description: '[PAGE] Campaign Dashboard - Campaign metrics and analytics' },
    { id: 329, action: 'Campaigns:List', description: '[PAGE] Campaign List - View all campaigns' },
    // Case Management
    { id: 330, action: 'Case:Admin', description: 'Administer cases - manage assignments, transfers, and reassignments' },
    { id: 331, action: 'Case:Create', description: 'Create new cases and case records' },
    { id: 332, action: 'Case:Delete', description: 'Delete case records' },
    { id: 333, action: 'Case:Read', description: 'View and read case information, follow-ups, and case listings' },
    { id: 334, action: 'Case:Supervisor', description: 'Supervisory access for case operations and reassignments' },
    { id: 335, action: 'Case:Update', description: 'Update existing case information and details' },
    { id: 358, action: 'Case:Reopen', description: 'Reopen closed cases and selected assignments' },
    { id: 336, action: 'CaseAssignment:Create', description: 'Create new case assignments' },
    { id: 337, action: 'CaseAssignment:Delete', description: 'Remove case assignments' },
    { id: 338, action: 'CaseCategory:Read', description: 'View and manage case categories/issues/sub-issues (used in UI)' },
    { id: 352, action: 'Cases:Read', description: 'Access cases panel - agent-specific view' },
    { id: 353, action: 'CaseTransfer:Create', description: 'Initiate case transfers between agents/departments' },
    { id: 354, action: 'Case_Category:Create', description: 'Create new Case Category categories' },
    { id: 355, action: 'Case_Category:Delete', description: 'Delete Case Category' },
    { id: 356, action: 'Case_Category:Read', description: 'View issue categories and sub-issues' },
    { id: 357, action: 'Case_Category:Update', description: 'Update existing Case Category categories' },
    { id: 350, action: 'CaseReport:Admin', description: 'Access all case reporting, analytics, and statistics (used in UI)' },
    { id: 351, action: 'CaseReport:Read', description: 'Access case reporting, analytics, and statistics (used in UI)' },
    { id: 390, action: 'Kase:Read', description: 'View and read case information (legacy - used in UI)' },
    // Case Management Pages
    { id: 339, action: 'CaseManagement:AgentPanel', description: '[PAGE] Agent Panel - Call handling and case creation' },
    { id: 340, action: 'CaseManagement:Branches', description: '[PAGE] Branches Management - Branches data management' },
    { id: 341, action: 'CaseManagement:CaseAssignment', description: '[PAGE] Case Assignment - Assign cases to agents' },
    { id: 342, action: 'CaseManagement:CaseCategories', description: '[PAGE] Case Categories - Manage issue categorization' },
    { id: 343, action: 'CaseManagement:CaseReport', description: '[PAGE] Case Report - Case analytics and reporting' },
    { id: 344, action: 'CaseManagement:CasesPanel', description: '[PAGE] Cases Panel - Agent view of cases' },
    { id: 345, action: 'CaseManagement:CaseTransfer', description: '[PAGE] Case Transfer - Transfer cases between agents' },
    { id: 346, action: 'CaseManagement:CustomerHelper', description: '[PAGE] Customer Helper - Customer information lookup' },
    { id: 347, action: 'CaseManagement:Dashboard', description: '[PAGE] Case Management Dashboard' },
    { id: 348, action: 'CaseManagement:FollowUpCases', description: '[PAGE] Follow Up Cases - Track pending case follow-ups' },
    { id: 349, action: 'CaseManagement:Province', description: '[PAGE] Province Management - Geographic data management' },
    // CDR & Calls
    { id: 358, action: 'Cdr:Read', description: 'Access Call Detail Records (CDR) reports' },
    { id: 382, action: 'Incoming:Read', description: 'View incoming call reports and detailed metrics' },
    { id: 383, action: 'IncomingCalls:Admin', description: 'Access all incoming calls reporting, analytics, and statistics (used in UI)' },
    { id: 473, action: 'Disposition_Filter:Read', description: 'Use agent and system disposition filters on call reports' },
    { id: 391, action: 'Outgoing:Read', description: 'View outgoing call reports and CDR data' },
    { id: 392, action: 'OutgoingCalls:Admin', description: 'Access all outgoing calls  reporting, analytics, and statistics (used in UI)' },
    { id: 409, action: 'ReceivedCall:Read', description: 'View received call reports and analysis' },
    { id: 406, action: 'QueueLog:Read', description: 'View queue logs and call queue statistics' },
    { id: 410, action: 'Refresh', description: 'Refresh call center data and statistics' },
    // Company
    { id: 359, action: 'Company:Create', description: 'Create new companies' },
    { id: 360, action: 'Company:Delete', description: 'Delete companies' },
    { id: 361, action: 'Company:Read', description: 'View company information' },
    { id: 362, action: 'Company:Update', description: 'Update company information' },
    // Customer Helper
    { id: 363, action: 'CustomerHelper:Read', description: 'Access customer helper tools and information lookup' },
    // Dashboard
    { id: 364, action: 'Dashboard:Agents', description: 'View agent status dashboard and performance' },
    { id: 365, action: 'Dashboard:CallQueues', description: 'View call queue statistics dashboard' },
    { id: 366, action: 'Dashboard:IncomingCalls', description: 'View incoming calls dashboard widget and metrics' },
    { id: 367, action: 'Dashboard:KPI', description: 'View KPI (Key Performance Indicator) dashboard' },
    { id: 368, action: 'Dashboard:OutgoingCalls', description: 'View outgoing calls dashboard widget and metrics' },
    { id: 369, action: 'Dashboard:SDP', description: 'Access SDP dashboard and overview' },
    // Department
    { id: 370, action: 'Department:Create', description: 'Create new departments' },
    { id: 371, action: 'Department:Delete', description: 'Delete departments' },
    { id: 372, action: 'Department:Read', description: 'View departments' },
    { id: 373, action: 'Department:Update', description: 'Update existing departments' },
    // Financial
    { id: 374, action: 'Financial:AirplaneTicket', description: '[PAGE] Airplane Tickets - Ticket booking management' },
    { id: 375, action: 'Financial:Hawala', description: '[PAGE] Hawala - Money transfer transaction management' },
    // Group
    { id: 376, action: 'Group:Create', description: 'Create new phone number groups' },
    { id: 377, action: 'Group:Delete', description: 'Delete phone number groups' },
    { id: 378, action: 'Group:Read', description: 'View and manage phone number groups' },
    { id: 379, action: 'Group:Update', description: 'Update existing phone number groups' },
    // Hawala
    { id: 380, action: 'Hawala:Create', description: 'Create new hawala (money transfer) transactions' },
    { id: 381, action: 'Hawala:Read', description: 'View pending hawala (money transfer) transactions' },
    // Issue
    { id: 384, action: 'Issue:Create', description: 'Create new issue categories' },
    { id: 385, action: 'Issue:Delete', description: 'Delete issue categories' },
    { id: 386, action: 'Issue:Read', description: 'View issue categories and sub-issues' },
    { id: 387, action: 'Issue:Update', description: 'Update existing issue categories' },
    // IVR Content
    { id: 388, action: 'IvrContent:Read', description: 'View IVR content and configuration' },
    { id: 389, action: 'IvrContent:Update', description: 'Update IVR content and configuration' },
    // Password
    { id: 393, action: 'Password:Change', description: 'Change user password' },
    { id: 394, action: 'Password:Reset', description: 'Reset user password (admin function)' },
    // Permission Management
    { id: 395, action: 'Permission:Create', description: 'Create new permissions' },
    { id: 396, action: 'Permission:Read', description: 'View and list permissions' },
    { id: 397, action: 'Permission:Update', description: 'Update existing permissions' },
    // Phone
    { id: 398, action: 'Phone:Create', description: 'Create new phone numbers' },
    { id: 399, action: 'Phone:Delete', description: 'Delete phone numbers' },
    { id: 400, action: 'Phone:Read', description: 'View phone number management and inventory' },
    { id: 401, action: 'Phone:Update', description: 'Update existing phone numbers' },
    // Province
    { id: 402, action: 'Province:Create', description: 'Create new provinces' },
    { id: 403, action: 'Province:Delete', description: 'Delete provinces' },
    { id: 404, action: 'Province:Read', description: 'View and manage provinces (geographic locations)' },
    { id: 405, action: 'Province:Update', description: 'Update existing provinces' },
    // Real Time Monitoring
    { id: 407, action: 'RealTime:ActiveCalls', description: 'View currently active calls in real-time' },
    { id: 408, action: 'RealTime:QueueInformation', description: 'View real-time queue information and current status' },
    // Reporting
    { id: 411, action: 'Reporting:IVR', description: 'Access IVR (Interactive Voice Response) reports' },
    { id: 412, action: 'Reporting:OBD', description: 'Access OBD (Operator Billing Data) reports' },
    { id: 413, action: 'Reporting:ProcessedSMS', description: 'Access processed SMS reports' },
    { id: 414, action: 'Reporting:ReceivedSMS', description: 'Access received SMS reports and statistics' },
    { id: 415, action: 'Reporting:SentSMS', description: 'Access sent SMS reports and statistics' },
    // Service
    { id: 432, action: 'Service:Create', description: 'Create new services in the system' },
    { id: 433, action: 'Service:Delete', description: 'Delete services from the system' },
    { id: 434, action: 'Service:Read', description: 'View services in the system' },
    { id: 435, action: 'Service:Update', description: 'Update existing services' },
    { id: 436, action: 'ServiceType:Read', description: 'View service types configuration' },
    // Settings
    { id: 438, action: 'Settings:AgentProductivityReport', description: 'Access all session reporting, analytics, and statistics (used in UI)' },
    { id: 439, action: 'Settings:Companies', description: '[PAGE] Company Management - Manage company information' },
    { id: 440, action: 'Settings:Departments', description: '[PAGE] Department Management - Manage departments' },
    { id: 441, action: 'Settings:Permissions', description: '[PAGE] Permission Management - View and manage permissions' },
    { id: 442, action: 'Settings:Roles', description: '[PAGE] Role Management - Create and manage roles' },
    { id: 443, action: 'Settings:SessionReport', description: 'Access all session reporting, analytics, and statistics (used in UI)' },
    { id: 444, action: 'Settings:Users', description: '[PAGE] User Management - Create and manage users' },
    { id: 463, action: 'Settings:AuditLog', description: '[PAGE] Audit Log - View system audit trail' },
    // Session Reports
    { id: 437, action: 'SessionReport:Admin', description: 'Access all session reporting, analytics, and statistics (used in UI)' },
    // SMS Queue
    { id: 445, action: 'SmsQueue:Create', description: 'Create SMS queue entries' },
    { id: 446, action: 'SmsQueue:Delete', description: 'Delete SMS queue entries' },
    { id: 447, action: 'SmsQueue:Read', description: 'View SMS queue and pending messages' },
    { id: 448, action: 'SmsQueue:Update', description: 'Update SMS queue entries' },
    // System Configuration
    { id: 449, action: 'SystemConfig:Read', description: 'View system configuration' },
    { id: 450, action: 'SystemConfig:Update', description: 'Update system configuration' },
    // Ticket
    { id: 451, action: 'Ticket:Create', description: 'Create new tickets' },
    { id: 452, action: 'Ticket:Read', description: 'View and manage ticket records' },
    // Voicemail
    { id: 453, action: 'VoiceMail:Delete', description: 'Delete voicemail messages' },
    { id: 454, action: 'VoiceMail:Read', description: 'Access and manage voicemail messages' },
    // Chat
    { id: 455, action: 'ChatRoom:Create', description: 'Create chat rooms' },
    { id: 456, action: 'ChatRoom:Read', description: 'View chat rooms and members' },
    { id: 457, action: 'ChatRoom:Update', description: 'Update chat rooms and members' },
    { id: 458, action: 'ChatRoom:Delete', description: 'Delete chat rooms and members' },
    { id: 459, action: 'ChatMessage:Create', description: 'Create chat messages' },
    { id: 460, action: 'ChatMessage:Read', description: 'View chat messages' },
    { id: 461, action: 'ChatMessage:Update', description: 'Update chat messages' },
    { id: 462, action: 'ChatMessage:Delete', description: 'Delete chat messages' },
    { id: 464, action: 'CALL:SUPERVISING', description: 'Supervise calls' },
    // District
    { id: 465, action: 'District:Create', description: 'Create new districts' },
    { id: 466, action: 'District:Delete', description: 'Delete districts' },
    { id: 467, action: 'District:Read', description: 'View districts' },
    { id: 468, action: 'District:Update', description: 'Update existing districts' },
    //  Pause Call
    { id: 469, action: 'PAUSE_CALL', description: 'View pause call option' },
    // AGENT STATIICS
    { id: 470, action: 'AGENT_STATICS', description: 'View agent statistics' },
    // Wallboard Read 
    { id: 471, action: 'WALLBOARD:READ', description: 'View wallboard' },
    // Break Report Admin
    { id: 472, action: 'BREAK_REPORT:READ', description: 'View break report' },
];
export const ALL_CALL_CENTER_PERMISSION_DEFINITIONS = [
    ...SHARED_CALL_CENTER_PERMISSIONS,
    ...CRM_CALL_CENTER_PERMISSIONS,
];
const CALL_CENTER_ACTION_SET = new Set(ALL_CALL_CENTER_PERMISSION_DEFINITIONS.map((p) => p.action));
/** PickList rows for role form — prefers live IAM catalogue IDs when available. */
export function buildCallCenterPermissionCatalog(apiPermissions) {
    const byAction = new Map();
    for (const perm of apiPermissions) {
        if (perm.action && CALL_CENTER_ACTION_SET.has(perm.action)) {
            byAction.set(perm.action, perm);
        }
    }
    return ALL_CALL_CENTER_PERMISSION_DEFINITIONS.map((def) => {
        const fromApi = byAction.get(def.action);
        if (fromApi) {
            return {
                id: fromApi.id ?? def.id,
                action: fromApi.action ?? def.action,
                description: fromApi.description ?? def.description,
                active: fromApi.active !== false,
            };
        }
        return {
            id: def.id,
            action: def.action,
            description: def.description,
            active: true,
        };
    });
}
export function toRolePickListItem(perm) {
    const action = perm.action ?? String(perm.id ?? '');
    return {
        id: perm.id ?? action,
        name: action,
        label: perm.description || action,
        permission: perm,
    };
}
function normalizeRoleAssignedPermission(raw) {
    if (typeof raw === 'string') {
        return { action: raw, description: raw, active: true };
    }
    if (!raw || typeof raw !== 'object')
        return null;
    const o = raw;
    const action = String(o.action ?? o.name ?? o.permission ?? o.authority ?? '').trim();
    if (!action && o.id == null)
        return null;
    return {
        id: o.id,
        action: action || undefined,
        description: typeof o.description === 'string'
            ? o.description
            : typeof o.label === 'string'
                ? o.label
                : action || undefined,
        active: o.active !== false,
    };
}
export function rolePermissionAction(raw) {
    if (typeof raw === 'string')
        return raw.trim();
    if (raw && typeof raw === 'object') {
        const o = raw;
        return String(o.action ?? o.name ?? '').trim();
    }
    return '';
}
export function rolePermissionId(raw) {
    if (!raw || typeof raw !== 'object' || !('id' in raw))
        return undefined;
    const id = raw.id;
    return id == null || id === '' ? undefined : id;
}
export function permissionPickListItemsMatch(left, right) {
    const leftAction = left.name.trim().toLowerCase();
    const rightAction = right.name.trim().toLowerCase();
    if (leftAction && rightAction && leftAction === rightAction)
        return true;
    return left.id != null && right.id != null && String(left.id) === String(right.id);
}
export function matchesRolePermissionPickListItem(pickListItem, rolePermission) {
    const code = rolePermissionAction(rolePermission);
    if (code && code.toLowerCase() === pickListItem.name.toLowerCase())
        return true;
    const pid = rolePermissionId(rolePermission);
    return pid != null && String(pid) === String(pickListItem.id);
}
const ROLE_ADMIN_DEFINITION = SHARED_CALL_CENTER_PERMISSIONS.find((p) => p.action === 'ROLE_ADMIN');
/** IAM may omit `ROLE_ADMIN`; always expose it in the role permission PickList. */
function ensureRoleAdminPickListItem(apiPermissions, items) {
    if (!ROLE_ADMIN_DEFINITION)
        return;
    const fromApi = apiPermissions.find((p) => p.action?.toUpperCase() === 'ROLE_ADMIN');
    const roleAdminItem = toRolePickListItem(fromApi ?? {
        id: ROLE_ADMIN_DEFINITION.id,
        action: ROLE_ADMIN_DEFINITION.action,
        description: ROLE_ADMIN_DEFINITION.description,
        active: true,
    });
    if (!items.some((existing) => permissionPickListItemsMatch(existing, roleAdminItem))) {
        items.unshift(roleAdminItem);
    }
}
/** Live IAM catalogue (`user/api/permissions`) for role PickList — matches production front.naqdpay.com. */
export function buildIamPermissionPickList(apiPermissions) {
    const items = apiPermissions
        .filter((perm) => perm.active !== false && Boolean(perm.action || perm.id != null))
        .map(toRolePickListItem);
    ensureRoleAdminPickListItem(apiPermissions, items);
    return items;
}
/** IAM catalogue plus any permissions already on the role (so edit forms pre-select reliably). */
export function buildRolePermissionPickList(apiPermissions, rolePermissions) {
    const items = buildIamPermissionPickList(apiPermissions);
    for (const raw of rolePermissions ?? []) {
        const perm = normalizeRoleAssignedPermission(raw);
        if (!perm || perm.active === false)
            continue;
        const item = toRolePickListItem(perm);
        if (items.some((existing) => permissionPickListItemsMatch(existing, item)))
            continue;
        items.push(item);
    }
    return items;
}
